export default "__VITE_ASSET__Dh6S2SHI__"